import { Link, Text } from 'platform-components';
import React from 'react';

import AccordionItem from 'common.components/accordion/__item/accordion__item';
// @ts-ignore
import { IconPlus } from 'common.components/icon2';
import { ACCORDION_ITEMS } from 'common.components/lesson-view.assignment/typings';

interface Props {
    onAddClick: () => void;
    title: string;
    placeholder: string;
    addText: string;
    errorMessage: string | null;
}

export const AssignmentEmptyList = ({ onAddClick, title, placeholder, addText, errorMessage }: Props) => {
    const fullContent = (
        <>
            <Text id={placeholder} />
            <Link mix="assignment__add-link" onClick={onAddClick} pseudo theme={Link.THEME.INHERIT}>
                <IconPlus />
                <Text id={addText} weight={Text.WEIGHT.M} />
            </Link>
            {errorMessage && (
                <div className="assignment__error">
                    <Text id={errorMessage} />
                </div>
            )}
        </>
    );

    return (
        <div className="assignment__empty-list">
            <AccordionItem
                id={ACCORDION_ITEMS.STUDENTS}
                isExpanded={true}
                isWithIcon={false}
                item={{
                    fullContent,
                    previewContent: null,
                }}
                title={title}
            />
        </div>
    );
};
